import { render, staticRenderFns } from "./ApplicationModeSwitcher.vue?vue&type=template&id=3a39c516&scoped=true&"
import script from "./ApplicationModeSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ApplicationModeSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationModeSwitcher.vue?vue&type=style&index=0&id=3a39c516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39c516",
  null
  
)

export default component.exports